import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindPromiseCreators } from 'redux-saga-routines';
import { reduxForm, Field, Form } from 'redux-form/immutable';

import MenuItem from '@material-ui/core/MenuItem';
import Tab from '@material-ui/core/Tab';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import { Map } from 'immutable';

import ReduxDialog from '../../Common/ReduxDialog/index';
import { toJS, name } from '../../../utils/helper';
import { hasPermission } from '../../../utils/authenticated';

import {
  fetchCustomerRoutine,
  fetchEmployeesRoutine,
  saveCustomerFormHandler,
} from '../../../redux/routines';

import { showDialog, hideDialog, showError } from '../../../redux/actions/dialogs';
import {
  renderAddressesGrid,
  renderContactsGrid,
  renderSelect,
  renderTags, renderTextField
} from '../../../utils/reduxforms';
import {
  ADDRESS_DIALOG,
  CONFIRM_DIALOG,
  CONTACT_DIALOG,
  CUSTOMER_DIALOG,
} from '../../../redux/constants/dialogs';

import styles from './styles';
import { required } from '../../../utils/formvalidation';
import { getDialogContextValue } from '../../../redux/selectors';

// const validate = (values, props) => {
//   const errors = {};
//   // TODO implement valdiation
//   // const requiredFields = ['firstName', 'lastName', 'mobile'];
//   // requiredFields.forEach((field) => {
//   //   if (!valuesObj[field]) {
//   //     errors[field] = `Require a ${splitCamelCase(field)} field`;
//   //   }
//   // });
//   //
//   // if ((valuesObj.firstName && valuesObj.lastName) || valuesObj.email) {
//   //   props.employees.forEach((employee) => {
//   //     // if ((employee.firstName.toLowerCase() === valuesObj.firstName.toLowerCase() &&
//   //     // employee.lastName.toLowerCase() === valuesObj.lastName.toLowerCase())) {
//   //     //   errors.firstName = 'User already exist';
//   //     //   errors.lastName = 'User already exist';
//   //     // }
//   //     if (employee.id !== valuesObj.id && employee.email === valuesObj.email) {
//   //       errors.email = 'Email already exist';
//   //     }
//   //   });
//   // }
//   // if (valuesObj.mobile && !validateMobile(valuesObj.mobile)) {
//   //   errors.mobile = 'Only Numeric Characters';
//   // }
//   // if (valuesObj.email && !validateEmail(valuesObj.email)) {
//   //   errors.email = 'Invalid email address';
//   // }
//   return errors;
// };

// const handleRequestClose = (props, customer) => {
//   if (props.onRequestClose) {
//     props.onRequestClose(customer);
//   } else {
//     props.hideDialog(CUSTOMER_DIALOG);
//   }
// };

class CustomerDialog extends Component {
  state = {
    tab: 0,
  };

  componentWillMount() {
    this.props.fetchEmployees();

    this.setState({
      editable: hasPermission(['JobCreator', 'Administrator']),
    });
  }

  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.customer && nextProps.customer.logo) {
  //     firebaseStorage.ref(getAccountPath(`/customers/${nextProps.customer.logo}`)).getDownloadURL().then((logo) => {
  //         this.setState({
  //           logo,
  //         });
  //       }
  //     );
  //   }
  // }

  handleShowAddress = (address) => {
    this.props.showDialog(ADDRESS_DIALOG, {
      address,
      onRequestClose: (addr) => {
        this.props.hideDialog(ADDRESS_DIALOG);
        if (addr) {
          this.props.addAddress(this.props.customer, addr);
        }
      },
    });
  };

  handleShowContact = (contact) => {
    this.props.showDialog(CONTACT_DIALOG, {
      contact,
      onRequestClose: (ctct) => {
        this.props.hideDialog(CONTACT_DIALOG);
        if (ctct) {
          this.props.addContact(this.props.customer, ctct);
        }
      },
    });
  };

  handleRemoveAddress = (customer, address) => {
    const context = {
      type: 'warning',
      title: 'Remove Address?',
      message: 'Are you sure you wish to remove this address?',
      buttons: [
        <Button
          variant="text"
          onClick={() => this.props.hideDialog(CONFIRM_DIALOG)}
        >Cancel</Button>,
        <Button
          variant="text"
          onClick={() => {
            this.props.hideDialog(CONFIRM_DIALOG);
            this.props.removeAddress(customer, address);
          }}
        >Remove</Button>,
      ],
    };

    this.props.showDialog(CONFIRM_DIALOG, context);
  };

  handleRemoveContact = (customer, contact) => {
    const context = {
      type: 'warning',
      title: 'Remove Contact?',
      message: 'Are you sure you wish to remove this contact?',
      buttons: [
        <Button
          variant="text"
          onClick={() => this.props.hideDialog(CONFIRM_DIALOG)}
        >Cancel</Button>,
        <Button
          variant="text"
          onClick={() => {
            this.props.hideDialog(CONFIRM_DIALOG);
            this.props.removeContact(customer, contact);
          }}
        >Remove</Button>,
      ],
    };

    this.props.showDialog(CONFIRM_DIALOG, context);
  };

  handleSetPrimary = (customer, contact) => {
    console.log('handleSetPrimary', contact);
    // return
  };

  renderOverview(customer, editable) {
    const { employees } = this.props;
    return (
      <Grid container spacing={8} style={styles.overview}>
        <Grid item xs={12} sm={12}>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <Field
                name="name"
                component={renderTextField}
                label="Name"
                fullWidth
                readOnly={!editable}
                validate={required}
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                name="customerManager.id"
                component={renderSelect}
                label="Customer Manager"
                fullWidth
                readOnly={!editable}
                validate={required}
              >
                {(employees.data || []).map((employee) => {
                  return (<MenuItem key={employee.id} value={employee.id}>{name(employee)}</MenuItem>);
                })}
              </Field>
            </Grid>

            <Grid item xs={12}>
              <Field
                name="tags"
                label="Tags"
                placeholder="Add new tag..."
                component={renderTags}
                isMulti
                allowCreate
              />
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Field
              name="notes"
              component={renderTextField}
              label="Notes"
              fullWidth
              rows={3}
              multiline
              readOnly={!editable}
            />
          </Grid>
        </Grid>

        {/*<Grid item xs={12} sm={6} style={styles.logo}>*/}
          {/*<Field*/}
            {/*name="logo"*/}
            {/*component={renderImageUpload}*/}
            {/*type="customer"*/}
            {/*readOnly={!editable}*/}
            {/*fullWidth*/}
            {/*path={getAccountPath(`/customers/${customer.id}/logo`)}*/}
          {/*/>*/}
        {/*</Grid>*/}
      </Grid>);

    /*
    src={this.state.logo}
            height={300}
            width={300}
            onUpload={this.handleLogoUpload}/> : <img alt="Staza" src={this.state.logo} height="300" width="300"
     */
  }

  renderContacts = (customer, editable) => {
    return (
      <Field
        name="contacts"
        component={renderContactsGrid}
        editable={editable}
        showDialog={this.props.showDialog}
      />);
  };

  renderAddresses = (customer, editable) => {
    return (<Field
      name="addresses"
      component={renderAddressesGrid}
      editable={editable}
      showDialog={this.props.showDialog}
    />)
  };

  render() {
    const { handleSubmit, initialValues, hideDialog, submit } = this.props;
    const { editable, uploading, tab } = this.state;

    const customer = initialValues.toJS();

    const actions = editable ? [
      <Button
        key="cancel"
        variant="text"
        onClick={() => hideDialog(CUSTOMER_DIALOG)}
        disabled={uploading}
      >Cancel</Button>,
      <Button
        key="save"
        variant="contained"
        color="primary"
        autoFocus
        onClick={() => submit(CUSTOMER_DIALOG)}
        disabled={uploading}
      >Save</Button>,
    ] : [<Button
      key="close"
      variant="text"
      color="primary"
      onClick={() => hideDialog(CUSTOMER_DIALOG)}
    >Close</Button>];

    return (
      <ReduxDialog
        name={CUSTOMER_DIALOG}
        title={customer.name || 'Create New Customer'}
        actions={actions}
        bodyStyle={styles.body}
        fullWidth
        maxWidth="md"
      >
        <Form onSubmit={handleSubmit(saveCustomerFormHandler)}>
          <AppBar position="static">
            <Tabs value={tab} onChange={(evt, tab) => this.setState({ tab })}>
              <Tab label="Overview"/>
              <Tab label="Contacts"/>
              <Tab label="Addresses"/>
            </Tabs>
          </AppBar>
          {tab === 0 && this.renderOverview(customer, editable)}
          {tab === 1 && this.renderContacts(customer, editable)}
          {tab === 2 && this.renderAddresses(customer, editable)}
        </Form>
      </ReduxDialog>
    );
  }
}

CustomerDialog.propTypes = {
  fetchCustomer: PropTypes.func.isRequired,
  fetchEmployees: PropTypes.func.isRequired,
  customer: PropTypes.object,
  employees: PropTypes.object.isRequired,

  showDialog: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
};

const form = reduxForm({
  form: CUSTOMER_DIALOG,  // a unique identifier for this form
  onSubmitSuccess: (result, dispatch, props) => {
    props.onSave ? props.onSave(result.response.data) : null;
    props.hideDialog(CUSTOMER_DIALOG);
  },
})(CustomerDialog);

function mapStateToProps(state) {
  return {
    initialValues: getDialogContextValue(state)(CUSTOMER_DIALOG, 'customer') || new Map(),
    onSave: getDialogContextValue(state)(CUSTOMER_DIALOG, 'onSave'),
    employees: toJS(state.getIn(['employees', 'employees'])),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      fetchCustomer: fetchCustomerRoutine.trigger,
      fetchEmployees: fetchEmployeesRoutine.trigger,

      showDialog,
      hideDialog,
      showError,
    }, dispatch),
    ...bindPromiseCreators({
      // saveCustomerLogo: saveCustomerLogoPromise,
    }, dispatch)
  };

}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Customers/CustomerDialog/index.js